import { useState, useEffect } from 'react';
import { StateViewInterface } from '../interfaces/stateViews.interface';
import ListadoSolicitudes from '../views/listadoSolicitudes';
import GenerarSolicitud from '../views/generarSolicitud';
import LiquidarRemesarSolicitud from '../views/liquidarRemesarSolicitud';
import DesrecaudarSolicitud from '../views/desrecaudarSolicitud';
import GenerarRecaudacion from '../views/generarRecaudacion';
import { RespuestaSolicitudesPrepagoDto } from '../models';

const Prepagos: React.FC = () => {

    const [ showViews, setShowViews ] = useState<StateViewInterface>({ 
        showListadoSolicitudes: true,
        showGenerarSolicitud: false,
        showGenerarLiquidacion: false,
        showGenerarRecaudacion: false,
        showGenerarDesrecaudacion: false,
        showRemesarPrepago: false
    })

    const [idSolicitud, setIdSolicitud] = useState<number>(0);
    const [solicitud, setSolicitud] = useState<RespuestaSolicitudesPrepagoDto|null>(null);
    // Estado para controlar qué acordeón debe estar expandido después de una recaudación
    const [acordeonExpandido, setAcordeonExpandido] = useState<string | null>('solicitudesGeneradas');

    const setViewToShow = (view: keyof StateViewInterface) => {
        setShowViews(prev => {
            const newState: StateViewInterface = {} as StateViewInterface;
            Object.keys(prev).forEach(key => {
                newState[key as keyof StateViewInterface] = key === view;
            });
            return newState
        })
    };

    // Función para manejar el éxito de la recaudación
    const handleRecaudacionSuccess = () => {
        // Expandir el acordeón de solicitudes liquidadas y recaudadas
        setAcordeonExpandido('solicitudesLiquidadas');
        setViewToShow('showListadoSolicitudes');
    };

    // Función para manejar el éxito de la reversión de la recaudación
    const handleReversarRecaudacionSuccess = () => {
        // Expandir el acordeón de solicitudes liquidadas y recaudadas
        setAcordeonExpandido('solicitudesLiquidadas');
        setViewToShow('showListadoSolicitudes');
    };

    // Limpiar el estado del acordeón expandido cuando se cambie de vista
    useEffect(() => {
        if (!showViews.showListadoSolicitudes) {
            setAcordeonExpandido(null);
        }
    }, [showViews.showListadoSolicitudes]);

    return (
        <>
            { showViews.showListadoSolicitudes && <ListadoSolicitudes 
                setViewToShow={setViewToShow} 
                setIdSolicitud={setIdSolicitud} 
                setSolicitud={setSolicitud}
                acordeonExpandido={acordeonExpandido}
                setAcordeonExpandido={setAcordeonExpandido}
            />}
            { showViews.showGenerarSolicitud && <GenerarSolicitud setViewToShow={setViewToShow} />}
            { showViews.showGenerarLiquidacion && <LiquidarRemesarSolicitud idSolicitud={idSolicitud} setViewToShow={setViewToShow} setIdSolicitud={setIdSolicitud} isLiquidar={true} />}
            { showViews.showGenerarRecaudacion && <GenerarRecaudacion 
                setViewToShow={setViewToShow} 
                solicitud={solicitud}
                onRecaudacionSuccess={handleRecaudacionSuccess}
            />}
            { showViews.showGenerarDesrecaudacion && <DesrecaudarSolicitud 
                idSolicitud={idSolicitud} 
                setViewToShow={setViewToShow} 
                setSolicitud={setIdSolicitud}
                onReversarRecaudacionSuccess={handleReversarRecaudacionSuccess}
            />}
            { showViews.showRemesarPrepago && <LiquidarRemesarSolicitud idSolicitud={idSolicitud} setViewToShow={setViewToShow} setIdSolicitud={setIdSolicitud} isLiquidar={false} />}
        </>
    )
}

export default Prepagos